import * as React from 'react';

import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';

// Lazy-loaded to avoid pulling in CoachChat → SSELink → ApolloLink at module-load
// time, which breaks unrelated test suites that transitively import this provider.
const CoachChatContainer = React.lazy(
  () => import('bundles/search-common/components/experiments/aiSearchOnLohp/CoachChatContainer')
);

function SearchCoachProvider({ children }: React.PropsWithChildren) {
  return (
    <CoachStateProvider>
      {children}
      <React.Suspense fallback={null}>
        <CoachChatContainer />
      </React.Suspense>
    </CoachStateProvider>
  );
}

export default SearchCoachProvider;
